import React, { useMemo } from "react";
import DOMPurify from "dompurify";

// Sanitize once per content string and render
export default function RichText({ html, className = "prose-body max-w-3xl" }) {
  const safe = useMemo(() => {
    if (!html) return "";
    return DOMPurify.sanitize(html, {
      ALLOWED_TAGS: ["p", "br", "strong", "em", "u", "s", "code", "h2", "h3", "ul", "ol", "li", "a", "span", "blockquote"],
      ALLOWED_ATTR: ["href", "target", "rel", "style"],
      ALLOWED_URI_REGEXP: /^(?:(?:https?|mailto|tel|\/|#):|[^a-z]|[a-z+.-]+(?:[^a-z+.\-:]|$))/i,
    });
  }, [html]);
  if (!safe) return null;
  return <div className={className} data-testid="rich-text" dangerouslySetInnerHTML={{ __html: safe }} />;
}

// Detect: is this string already HTML, or plain text?
export function isHtml(s) {
  return typeof s === "string" && /<[a-z][\s\S]*>/i.test(s);
}

// Convert legacy plain text (newline-separated paragraphs) to simple HTML
export function plainToHtml(s) {
  if (!s) return "";
  if (isHtml(s)) return s;
  const paras = s.split(/\n+/).filter(Boolean);
  return paras.map(p => `<p>${escapeHtml(p)}</p>`).join("");
}

function escapeHtml(s) {
  return s
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;");
}
